import { render, staticRenderFns } from "./ThreadColors.vue?vue&type=template&id=af0fcaac&scoped=true"
import script from "./ThreadColors.vue?vue&type=script&lang=js"
export * from "./ThreadColors.vue?vue&type=script&lang=js"
import style0 from "./ThreadColors.vue?vue&type=style&index=0&id=af0fcaac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0fcaac",
  null
  
)

export default component.exports